import StoriesUserVotedOn from "%/dynamic-component-editor/standard-pages/voted-stories-page/StoriesUserVotedOn.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyVotedStories extends LegacyEntity {
  get elements() {
    return {
      StoriesUserVotedOn,
    };
  }
}
